import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DocumentExchangeService } from 'src/app/services/document-exchange.service';
import { RequestInProgressService } from '@trivelope/triv-ui-tools-lib';
import { Environment } from 'src/app/classes/environment';


@Injectable({
  providedIn: 'root'
})
export class ExchangeGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private documentExchangeService: DocumentExchangeService,
    private requestInProgressService: RequestInProgressService,
    private router: Router,
    @Inject('environment') private environment: Environment,
  ) { }

  // Logic to determine if the route can be activated
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {

    if (this.environment.features.austauschOnlyVisibleWhenCategorySelected === true) {
      const user = this.authService.getCurrentUser();
      const bAdmin = this.authService.isAdmin();

      if (bAdmin) {
        return true;
      }

      return this.documentExchangeService.getDocumentExchangeCategories().pipe(
        map(categories => {
          if (categories && categories.length > 0) {
            return true;
          } else {
            this.router.navigate(['/']);
            return false;
          }
        }),
        catchError(() => {
          this.router.navigate(['/']);
          return of(false);
        })
      );

    } else  {

      return of(true);
    }
  }
}
